export default __webpack_public_path__ + "b876bafba23d3e2921bf4b7abd029566.svg";